const designSystem = {
  gallery: "גלריה",
  components: "קומפוננטות",
  handbook: "מדריך",
  searchComponents: "חיפוש קומפוננטות...",
  filterByCategory: "סינון לפי קטגוריה",
  allCategories: "כל הקטגוריות",
  stable: "יציב",
  beta: "בטא",
  deprecated: "מיושן",
  usedIn: "בשימוש ב",
  dependenciesLabel: "תלויות",
  propsLabel: "Props",
  filePath: "נתיב קובץ",
  noResults: "לא נמצאו קומפוננטות",
  totalComponents: "סה\"כ קומפוננטות",
  hasI18n: "i18n",
  hasCcId: "data-cc-id",
  catLayout: "פריסה",
  catNavigation: "ניווט",
  catDataDisplay: "תצוגת נתונים",
  catInput: "קלט",
  catFeedback: "משוב",
  catCanvas: "קנבס",
  catEditor: "עורך",
  catWidget: "ווידג'ט",
  registryOverview: "סקירת רג'יסטריות",
  conventions: "מוסכמות",
  componentAnatomy: "אנטומיית קומפוננטה",
  addingComponent: "הוספת קומפוננטה",
  required: "חובה",
  optional: "אופציונלי",
  expandDetails: "הרחב פרטים",
  collapseDetails: "כווץ פרטים",
  appPreview: "תצוגת אפליקציה",
  previewDevice: "מכשיר",
  previewPage: "עמוד",
  previewNote: "תצוגה מקדימה במצב mobile. אינטראקציה לא פעילה.",
  library: "ספריה",
  librarySearch: "חיפוש קומפוננטות...",
  libraryAll: "הכל",
  libraryInstalled: "מותקנים בלבד",
  libraryInstalledBadge: "מותקן",
  libraryDocs: "מסמכים",
  libraryUse: "העתק",
  libraryCopied: "הועתק!",
  libraryShadcn: "shadcn/ui",
  libraryMagicUi: "Magic UI",
  library21st: "21st.dev",
  library21stNote: "21st.dev מבוסס חיפוש — 10 קומפוננטות מומלצות מוצגות כאן. לעוד, בקשו מ-Claude לחפש ב-21st.dev.",
  librarySync: "סנכרון",
  libraryInstall: "התקן",
  libraryPreview: "תצוגה",
  libraryRefreshTitle: "רענן קטלוג דרך AI",
  // Design System page inline text
  previewLabel: "תצוגה מקדימה",
  backToGallery: "חזרה לגלריה",
  openNewTab: "פתח בחלון חדש",
  openInTab: "פתח בחלון",
} as const;
export default designSystem;
